<header class="flex header">
  <loading-overlay [isLoading]="isLoading() > 0" />
  <h2>{{ 'AssignRollPC.Title' | translateWF: 'Assign Rolls to PC' }} - {{ productionCardNumber }}</h2>
  <p class="p-2 rounded bg-green-950">
    {{ 'SelectedLbs' | translateWF: 'Selected Lbs' }}: {{ totalWeightOfRollsSelected() | number: '1.2-2' }} / {{ productionCardWeightInLbs | number: '1.2-2' }} Lbs
  </p>
</header>
<section class="content">
  <p-table [value]="rollsAvailable()">
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th>{{ 'AssignRollPC.SNo' | translateWF: 'S. No' }}</th>
        <th>{{ 'AssignRollPC.RollNo' | translateWF: 'Roll No' }}</th>
        <th>{{ 'AssignRoll.Item' | translateWF: 'Item' }}</th>
        <th>{{ 'AssignRoll.ProductType' | translateWF: 'Product Type' }}</th>
        <th>{{ 'AssignRollPC.FabricForm' | translateWF: 'Fabric Form' }}</th>
        <th>{{ 'AssignRollPC.KnittingOrder' | translateWF: 'Knitting Order' }}</th>
        <th>{{ 'AssignRollPC.Weight' | translateWF: 'Weight' }}</th>
        <th>{{ 'AssignRollPC.ProducedDate' | translateWF: 'Produced Date' }}</th>
        <th>{{ 'AssignRollPC.TransferIn' | translateWF: 'Transfer In' }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-roll let-i="rowIndex">
      <tr [ngClass]="{ 'bg-green-200': isRollSelected(roll) }" class="transition-colors duration-300">
        <td>
          @if (!isRollSelected(roll)) {
            <p-button icon="pi pi-plus" variant="outlined" [rounded]="true" (click)="pushRollsForAssign(roll)" />
          } @else {
            <p-button icon="pi pi-minus" [rounded]="true" (click)="deleteRollOfList(roll)" />
          }
        </td>

        <td>{{ i + 1 }}</td>
        <td>{{ roll.number }}</td>
        <td>{{ roll.itemCode }}</td>
        <td>----</td>
        <td>{{ fetchFabricTubularOrOpenWith(roll.expectedFabricCode) }}</td>
        <td>{{ roll.knittingOrderNumber }}</td>
        <td>{{ getRollTimeStamp(roll)?.weightInLbs }}</td>
        <td>{{ getRollTimeStamp(roll)?.timeStamp | date: 'dd/MM/yyyy' }}</td>
        <td>----</td>
      </tr>
    </ng-template>
  </p-table>
</section>
<footer>
  <p-button class="w-full" [label]="'AssignRollPC.Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" />
  <p-button class="w-full" [label]="'AssignRollPC.Assign' | translateWF: 'Assign'" (click)="assignRolls()" [disabled]="totalWeightOfRollsSelected() === 0" />
</footer>
<loading-overlay [isLoading]="isLoading() > 0" />
